/**
 * 产品对比表格数据配置 - 多语言支持
 * 返回根据当前语言动态生成的产品数据
 */

import i18n from '../i18n';

// 获取翻译后的频率限制文本
const getFrequencyLimitText = (type, params = {}) => {
  return i18n.t(`productComparison.frequencyLimits.${type}`, params);
};

// 获取所有产品对比数据（支持多语言）
export const getAllProductComparisonDataI18n = () => {
  const t = i18n.t.bind(i18n);
  
  return [
    {
      id: 'gpt-web',
      name: 'GPT Plus',
      platform: 'web',
      platformText: t('productComparison.platform.webOnly'),
      privacy: t('productComparison.privacy'),
      warranty: t('productComparison.warrantyText'),
      includedServices: ['GPT', 'Sora'],
      price: `${t('productComparison.pricePrefix')} $4.9/${t('productDetail.common.duration.month')}`,
      officialPrice: `$20/${t('productDetail.common.duration.month')}`,
      frequencyLimits: [
        getFrequencyLimitText('4o', { count: 180, hours: 3 }),
        getFrequencyLimitText('o3', { count: 40 }),
        getFrequencyLimitText('sora', { hours: 1, count: 20 })
      ]
    },
    {
      id: 'sora-web',
      name: 'Sora Plus',
      platform: 'web',
      platformText: t('productComparison.platform.webOnly'),
      privacy: t('productComparison.privacy'),
      warranty: t('productComparison.warrantyText'),
      includedServices: ['GPT', 'Sora'],
      price: `${t('productComparison.pricePrefix')} $4.9/${t('productDetail.common.duration.month')}`,
      officialPrice: `$20/${t('productDetail.common.duration.month')}`,
      frequencyLimits: [
        getFrequencyLimitText('4o', { count: 180, hours: 3 }),
        getFrequencyLimitText('o3', { count: 40 }),
        getFrequencyLimitText('sora', { hours: 1, count: 20 })
      ]
    },
    {
      id: 'claude-web',
      name: 'Claude Pro',
      platform: 'web',
      platformText: t('productComparison.platform.webOnly'),
      privacy: t('productComparison.privacy'),
      warranty: t('productComparison.warrantyText'),
      includedServices: ['GPT', 'Sora', 'Claude', 'Grok'],
      price: `${t('productComparison.pricePrefix')} $6.9/${t('productDetail.common.duration.month')}`,
      officialPrice: `$20/${t('productDetail.common.duration.month')}`,
      frequencyLimits: [
        getFrequencyLimitText('4o', { count: 180, hours: 3 }),
        getFrequencyLimitText('o3', { count: 40 }),
        getFrequencyLimitText('sora', { hours: 1, count: 20 }),
        getFrequencyLimitText('grok', { hours: 2, count: 50 }),
        getFrequencyLimitText('claude')
      ]
    },
    {
      id: 'grok-web',
      name: 'Grok Super',
      platform: 'web',
      platformText: t('productComparison.platform.webOnly'),
      privacy: t('productComparison.privacy'),
      warranty: t('productComparison.warrantyText'),
      includedServices: ['GPT', 'Sora', 'Claude', 'Grok'],
      price: `${t('productComparison.pricePrefix')} $6.9/${t('productDetail.common.duration.month')}`,
      officialPrice: `$30/${t('productDetail.common.duration.month')}`,
      frequencyLimits: [
        getFrequencyLimitText('4o', { count: 180, hours: 3 }),
        getFrequencyLimitText('o3', { count: 40 }),
        getFrequencyLimitText('sora', { hours: 1, count: 20 }),
        getFrequencyLimitText('grok', { hours: 2, count: 50 }),
        getFrequencyLimitText('claude')
      ]
    },
    {
      id: 'gpt-app',
      name: 'GPT Plus',
      platform: 'web+app',
      platformText: t('productComparison.platform.webAndApp'),
      privacy: t('productComparison.privacy'),
      warranty: t('productComparison.warrantyText'),
      includedServices: ['GPT', 'Sora'],
      price: `${t('productComparison.pricePrefix')} $17.9/${t('productDetail.common.duration.month')}`,
      officialPrice: `$20/${t('productDetail.common.duration.month')}`,
      frequencyLimits: [
        t('productComparison.frequencyLimits.officialLimit')
      ]
    }
  ];
};

// 根据产品ID获取单个产品数据
export const getProductComparisonByIdI18n = (id) => {
  const products = getAllProductComparisonDataI18n();
  return products.find(product => product.id === id);
};

// 根据平台类型筛选产品
export const getProductsByPlatformI18n = (platform) => {
  const products = getAllProductComparisonDataI18n();
  return products.filter(product => product.platform === platform);
}; 